import { Alert } from 'Components/common/Alert/Alert'
import React from 'react'

type AttributeHeaderAlertProps = {
    message?: string
}

export const AttributeHeaderAlert: React.FC<AttributeHeaderAlertProps> = ({
    message = 'Please provide inputs for below fields to complete the task',
}) => {
    return <Alert description={message} type="warning" showIcon />
}
